// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__3xHif","taskDetail":"styles_taskDetail__ZIJ0A"};